const initialState = {
  params: {
    courseSelect: null,
    groupTrainingSelect: null,
    groupOrganizationSelect: null,
    userSelect: null,
    daySelect: null,
    monthSelect: null,
    userDataAll: null,
  },
  userDataAll: null,
  userDataList: null,
  courseOptionSelect: null,
  groupTrainingOptionSelect: null,
  groupOrganizationOptionSelect: null,
  userOptionSelect: null,
  dayOptionSelect: null,
  monthOptionSelect: null,
  courseBeans: null,
  expertise: null,
  groupTraining: null,
  userData: null,
  courses: null,
  courseNameCurrent: null,
  windowScrollX: 0,
  windowScrollY: 0,
  groupTrainings: null,
  groupTrainingName: null,
};

function findUser(params, userDataAll) {
  const userDataList = [];
  if (userDataAll) {
    userDataAll.map((item) => {
      if (
        params.courseSelect === null &&
        params.groupTrainingSelect === null &&
        params.groupOrganizationSelect === null &&
        params.userSelect === null &&
        params.daySelect === null &&
        params.monthSelect === null
      ) {
        userDataList.push(item);
      } else if (
        params.courseSelect !== null ||
        params.groupTrainingSelect !== null ||
        params.groupOrganizationSelect !== null ||
        params.userSelect !== null ||
        params.daySelect !== null ||
        params.monthSelect !== null
      ) {
        var userSelect = true;
        var daySelect = true;
        var monthSelect = true;
        var courseSelect = true;
        var courseSelectFound = false;
        var groupTrainingSelect = true;
        var groupTrainingSelectFound = false;
        var groupOrganizationSelect = true;

        if (params.userSelect !== null) {
          if (params.userSelect === item.id) {
            userSelect = true;
          } else {
            userSelect = false;
          }
        }
        if (params.daySelect !== null) {
          if (params.daySelect === item.dayBirthday) {
            daySelect = true;
          } else {
            daySelect = false;
          }
        }

        if (params.monthSelect !== null) {
          if (params.monthSelect === item.monthBirthday) {
            monthSelect = true;
          } else {
            monthSelect = false;
          }
        }

        if (params.groupOrganizationSelect !== null) {
          if (params.groupOrganizationSelect === item.groupOrganizationId) {
            groupOrganizationSelect = true;
          } else {
            groupOrganizationSelect = false;
          }
        }

        item.courseBeanList.map((obj) => {
          if (params.courseSelect !== null && !courseSelectFound) {
            if (params.courseSelect === obj.courseId) {
              courseSelect = true;
              courseSelectFound = true;
            } else {
              courseSelect = false;
            }
          }

          if (params.courseSelect !== null) {
            if (
              params.groupTrainingSelect !== null &&
              !groupTrainingSelectFound
            ) {
              if (
                params.groupTrainingSelect === obj.groupTrainingId &&
                params.courseSelect === obj.courseId
              ) {
                groupTrainingSelect = true;
                groupTrainingSelectFound = true;
              } else {
                groupTrainingSelect = false;
              }
            }
          } else {
            if (
              params.groupTrainingSelect !== null &&
              !groupTrainingSelectFound
            ) {
              if (params.groupTrainingSelect === obj.groupTrainingId) {
                groupTrainingSelect = true;
                groupTrainingSelectFound = true;
              } else {
                groupTrainingSelect = false;
              }
            }
          }
        });

        if (
          userSelect &&
          daySelect &&
          monthSelect &&
          courseSelect &&
          groupTrainingSelect &&
          groupOrganizationSelect
        ) {
          userDataList.push(item);
        }
      }
    });
  }
  return userDataList;
}

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case "API_MEMBER_SEARCH":
      return {
        ...state,
        userDataAll: action.data.userDataList,
        userDataList: findUser(state.params, action.data.userDataList),
      };
    case "API_MEMBER_FIND_USER_DATA":
      return {
        ...state,
        params: action.params,
        userDataList: findUser(action.params, state.userDataAll),
      };
    case "API_MEMBER_GET_CRITERIA_SEARCH":
      return {
        ...state,
        courseOptionSelect: action.data.courseOptionSelect,
        groupTrainingOptionSelect: action.data.groupTrainingOptionSelect,
        userOptionSelect: action.data.userOptionSelect,
        dayOptionSelect: action.data.dayOptionSelect,
        monthOptionSelect: action.data.monthOptionSelect,
        groupOrganizationOptionSelect:
          action.data.groupOrganizationOptionSelect,
      };
    case "API_MEMBER_GET_USER":
      return {
        ...state,
        userData: action.data.userData,
        courses: action.data.courses,
      };
    case "API_MEMBER_GET_GROUP_TRAINING":
      return {
        ...state,
        groupTraining: action.data.groupTraining,
      };
    case "API_MEMBER_GET_OLD_GROUP_TRAINING":
      return {
        ...state,
        groupTrainings: action.data.groupTrainings,
        groupTrainingName: action.data.groupTrainingName,
      };
    case "API_MEMBER_GET_EXPERTISE":
      return {
        ...state,
        expertise: action.data.expertise,
      };
    case "API_MEMBER_DELETE_EXPERTISE":
      return {
        ...state,
        expertise: action.data.expertise,
      };
    case "API_MEMBER_ADD_EXPERTISE":
      return {
        ...state,
        expertise: action.data.expertise,
      };
    case "API_MEMBER_GET_COURSE":
      return {
        ...state,
        courseBeans: action.data.courseBeans,
        courseNameCurrent: action.data.courseNameCurrent,
      };
    case "MEMBER_SET_WINDOW_SCROLL":
      return {
        ...state,
        windowScrollX: action.windowScrollX,
        windowScrollY: action.windowScrollY,
      };
    default:
      return state;
  }
};

export default reducer;
